const map = {
	"./after-the-test-results-and-next-steps.webp": 4210,
	"./algebra-basics-finding-the-unknown.webp": 2659,
	"./angles-and-geometry.webp": 9241,
	"./application-timeline.webp": 648,
	"./area-perimeter-volume.webp": 3090,
	"./arrangement-and-seating-puzzles.webp": 1624,
	"./authors-purpose-why-the-text-was-written.webp": 2858,
	"./averages-and-the-mean.webp": 4174,
	"./avoiding-careless-mistakes.webp": 818,
	"./avoiding-distractor-answers.webp": 1729,
	"./building-a-bigger-vocabulary.webp": 6214,
	"./building-a-study-schedule.webp": 4230,
	"./cause-and-effect-in-reading.webp": 1438,
	"./cause-vs-correlation.webp": 254,
	"./characters-what-drives-them.webp": 9736,
	"./choosing-the-right-schools.webp": 5225,
	"./code-and-cipher-puzzles.webp": 7205,
	"./common-writing-mistakes.webp": 6096,
	"./comparing-two-texts.webp": 6844,
	"./connectives-and-linking-words.webp": 3626,
	"./data-sufficiency.webp": 5771,
	"./deductive-logic.webp": 858,
	"./descriptive-writing-using-the-senses.webp": 9498,
	"./discursive-writing.webp": 8728,
	"./drawing-conclusions.webp": 8449,
	"./editing-and-proofreading.webp": 7687,
	"./estimation-and-checking.webp": 3084,
	"./evaluating-arguments.webp": 1251,
	"./fact-vs-opinion.webp": 3807,
	"./factors-multiples-primes.webp": 6269,
	"./figurative-language-similes-metaphors.webp": 1390,
	"./finding-the-conclusion.webp": 4119,
	"./finding-the-main-idea.webp": 91,
	"./fractions-decimals-percentages.webp": 9872,
	"./grammar-essentials-for-tests.webp": 2765,
	"./helping-without-adding-pressure.webp": 6620,
	"./homophones-and-tricky-words.webp": 1643,
	"./how-placement-scores-work.webp": 2316,
	"./how-to-use-practice-tests.webp": 5142,
	"./identifying-evidence.webp": 1568,
	"./idioms-and-expressions.webp": 5885,
	"./imaginative-creative-writing.webp": 9479,
	"./inference-reading-between-the-lines.webp": 8093,
	"./is-coaching-necessary.webp": 3257,
	"./letter-and-number-patterns.webp": 6800,
	"./logical-number-puzzles.webp": 6833,
	"./managing-test-nerves.webp": 5869,
	"./matrix-and-grid-puzzles.webp": 1534,
	"./mental-maths-shortcuts.webp": 8215,
	"./multi-step-word-problems.webp": 5982,
	"./narrative-show-dont-tell.webp": 3662,
	"./negative-numbers.webp": 222,
	"./nonfiction-and-information-texts.webp": 4261,
	"./number-patterns-and-sequences.webp": 6494,
	"./oc-test-explained.webp": 1472,
	"./oc-vs-selective.webp": 8152,
	"./odd-one-out.webp": 735,
	"./on-screen-test-tips.webp": 4806,
	"./order-of-operations.webp": 3741,
	"./paragraphing.webp": 8652,
	"./parents-guide-support-without-pressure.webp": 4483,
	"./pattern-recognition-strategies.webp": 3196,
	"./percentages-of-amounts.webp": 7235,
	"./persuasive-techniques-rhetoric.webp": 3792,
	"./persuasive-writing-openings.webp": 154,
	"./persuasive-writing-structure.webp": 8544,
	"./plan-your-writing-in-5-minutes.webp": 3716,
	"./planning-a-story-in-minutes.webp": 6451,
	"./prefixes-suffixes-roots.webp": 6592,
	"./probability-basics.webp": 2803,
	"./quantitative-reasoning.webp": 2540,
	"./ratios-and-proportion.webp": 6419,
	"./read-widely-lift-your-score.webp": 9088,
	"./reading-graphs-and-tables.webp": 302,
	"./reading-the-question-carefully.webp": 8565,
	"./selective-test-explained.webp": 6300,
	"./sentence-completion-cloze.webp": 4240,
	"./sentence-variety.webp": 234,
	"./sequencing-order-of-events.webp": 9029,
	"./skimming-and-scanning.webp": 7733,
	"./sleep-and-nutrition-before-a-test.webp": 4217,
	"./smart-guessing-strategy.webp": 8069,
	"./spatial-reasoning-shapes.webp": 7564,
	"./speed-distance-time.webp": 9375,
	"./spelling-strategies.webp": 7758,
	"./spot-the-hidden-assumption.webp": 8253,
	"./spotting-flawed-reasoning.webp": 6299,
	"./summarising-a-passage.webp": 7902,
	"./synonyms-and-antonyms.webp": 8716,
	"./test-day-checklist.webp": 159,
	"./text-structure-how-writing-is-organised.webp": 7115,
	"./time-and-calendar-problems.webp": 7855,
	"./timing-never-run-out.webp": 5762,
	"./tone-and-mood-in-a-passage.webp": 8749,
	"./true-false-cannot-tell.webp": 1664,
	"./turn-word-problems-into-steps.webp": 318,
	"./understanding-arguments-in-a-text.webp": 4159,
	"./understanding-poetry.webp": 5670,
	"./units-and-measurement.webp": 1044,
	"./using-examples-and-evidence.webp": 6596,
	"./venn-diagram-logic.webp": 9636,
	"./verbal-reasoning-overview.webp": 9073,
	"./vocabulary-for-writing.webp": 7893,
	"./vocabulary-in-context.webp": 156,
	"./what-follows-logically.webp": 6198,
	"./what-thinking-skills-questions-test.webp": 147,
	"./what-to-do-when-you-are-stuck.webp": 2651,
	"./word-analogies.webp": 4636,
	"./work-backwards-eliminate-options.webp": 5710,
	"./working-with-money.webp": 4761,
	"./writing-a-satisfying-ending.webp": 9052,
	"./writing-a-strong-opening.webp": 1901,
	"./writing-dialogue-that-works.webp": 3212,
	"./writing-to-the-prompt.webp": 487,
	"./writing-under-time-pressure.webp": 3895
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9646;